import { ol_format } from "@omnia/exports/openlayers";

const wkbFormat = new ol_format.WKB({ hex: false })

export function convertBase64WellknownBinaryToGeometry(s: string) {

    const buffer = Uint8Array.from(atob(s), c => c.charCodeAt(0)).buffer;
    const geom = wkbFormat.readGeometry(buffer, { dataProjection: "EPSG:3857" })

    return geom

}